"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.workerCertificateTag = exports.WorkerJourneyStates = exports.MAX_WORKER_ID_LENGTH = exports.WORKER_ID_PATTERN = exports.WORKER_PII_FIELDS = exports.ACCESS_CODE_LENGTH_TYPE = exports.WorkerCategories = void 0;
exports.WorkerCategories = ['WORKER', 'INTERNAL'];
exports.ACCESS_CODE_LENGTH_TYPE = {
    SHORT: 8,
    LONG: 16,
};
exports.WORKER_PII_FIELDS = ['name', 'phone_number', 'id_details', 'upi', 'bank_account'];
exports.WORKER_ID_PATTERN = /^\d+$/;
exports.MAX_WORKER_ID_LENGTH = 20;
/**
 * Worker journey state, it happens for each task. User can skip at any state.
 * INTRO: Introduction to the task
 * CONFIG: Kind of metadata that is required before proceeding to the next states from worker side
 * TUTORIAL: Tutorial task, it teaches the worker how to do the task
 * TEST_TASK: Test task, it is used to evaluate the worker's readiness to do the main task
 * MAIN_TASK: Main task
 * SUCCESS_END: Worker has successfully completed the task
 * TEST_TASK_FAILED_END: Worker has been rejected at Test Task phase after validating worker's test task responses. Basically  we are assigning this state when there is scope to reattempt the test task
 * REFUSED_END: User has refused to do the task
 * TASK_COMPLETED: Admin has marked the task as completed explicitly via platform portal
 * EXPIRED_END: User has not completed the task within the deadline
 */
exports.WorkerJourneyStates = [
    'INTRO',
    'CONFIG',
    'TUTORIAL',
    'TEST_TASK',
    'TEST_TASK_VALIDATION',
    'TEST_TASK_FAILED_END',
    'MAIN_TASK',
    'SUCCESS_END',
    'REFUSED_END',
    'TASK_COMPLETED',
    'EXPIRED_END',
    'SURVEY',
];
exports.workerCertificateTag = '__WORKER_CERTIFICATE__';
//# sourceMappingURL=Index.js.map